/**
 * The SMS Opt-In feature will be completed in small parts,
 * which must be released together.
 * Epic: https://pumaglobal.atlassian.net/browse/EPIC-24
 */
export const SMS_OPT_IN_FEATURE_READY = false;
